module.exports = __webpack_public_path__ + "img/congrats.0590b044.png";